module.exports = __webpack_public_path__ + "img/4.618c05a4.png";